/** Geometric agent sigil — shared by the topbar trigger and the panel. */
export function AgentMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M8 1.4 14.6 8 8 14.6 1.4 8Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="2.5" fill="currentColor" />
    </svg>
  );
}
